// pages/Dashboard.tsx
import React, { useEffect, useState } from "react";
import { clearCache, getCache } from "../util/Cache";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"
import { Users, Menu, X, Home, Printer, User, WalletMinimalIcon, CircleGauge, Settings, Archive, Speaker } from 'lucide-react';

type sideBarType = { key: string; name: string; icon: React.JSX.Element; link: string; level?: string[]; }[];

export default function Dashboard({ SideBar }: { SideBar: sideBarType }) {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const [namaPetugas, setNamaPetugas] = useState("");
    const [userLevel, setUserLevel] = useState("");
    const [pilihPetugas, setPilihPetugas] = useState(false);

    const styles: { [key: string]: React.CSSProperties } = { 
        button: { backgroundColor: '#ff0000', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 16px', fontSize: '1.1rem',
                    fontWeight: 'bold', cursor: 'pointer', textDecoration: 'none', transition: 'background-color 0.3s ease', marginTop: '20px' },
    };

    useEffect(() => {
        checkUserDashboard();
    },[]);

    const handleSignOut = async () => {
        await clearCache("current_user").then(checkUserDashboard);
        navigate("/login");
    }
    

    const checkUserDashboard = async () => {
        try {
            const data = await getCache("current_user");
            if (!data || !data.nama) {
                navigate("/login");
                return;
            }

            setNamaPetugas(data.nama);
            setUserLevel(data.level);
        } catch (error) {
            console.log(error);
        }
    }

    const listSidebar = [
        { key : "dashboard",    name: "Dashboard", icon: <Home className="w-5 h-5 mr-3" />, link: "/dashboard", level : ["05", "15", "07", "04", "09"] },
        { key : "set_karyawan", name: "Pendataan Karyawan", icon: <Users className="w-5 h-5 mr-3" />, link: "/dashboard/datakaryawan" },
        { key : "set_loan",     name: "Aplikasi Gaji", icon: <WalletMinimalIcon className="w-5 h-5 mr-3" />, link: "/dashboard/gajiapp" },
        { key : "set_loan",     name: "Pengelolaan Akun", icon: <User className="w-5 h-5 mr-3" />, link: "/dashboard/akun" },
        { key : "settings",     name: "Settings", icon: <Settings className="w-5 h-5 mr-3" />, link: "#" },
        { key : "loket",        name: "Loket", icon: <Printer className="w-5 h-5 mr-3" />, link: "/dashboard/loket", level : ["05", "15", "09"] },
        { key : "penagihan",    name: "Penagihan", icon: <Archive className="w-5 h-5 mr-3" />, link: "/dashboard/penagihan" },
        { key : "penagihan-2",   name: "Penagihan2", icon: <Archive className="w-5 h-5 mr-3" />, link: "/dashboard/penagihan-2" },
        { key : "set_meter",    name: "Koreksi Meter", icon: <CircleGauge className="w-5 h-5 mr-3" />, link: "/dashboard/cekmeter", level : ["07"] },
        { key : "pengaduan",    name: "Laporan Pengaduan", icon: <Speaker className="w-5 h-5 mr-3" />, link: "/dashboard/pengaduan", level : ["04"] },
    ]

    const filteredSidebar = (() => {
        const dataSideBar = SideBar.length > 0 ? SideBar : listSidebar;
        const hasMatchingLevel = dataSideBar.some(item => item.level?.includes(userLevel));

        return hasMatchingLevel
            ? dataSideBar.filter(item => item.level?.includes(userLevel))
            : dataSideBar;
    })();

    return(
        <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
            {/* Sidebar */}
            <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-2xl transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static`}>
                <div className="flex items-center justify-between p-6 border-b">
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    Dashboard
                </h1>
                <button
                    onClick={() => setSidebarOpen(false)}
                    className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
                >
                    <X className="w-5 h-5" />
                </button>
                </div>
                
                <nav className="mt-8">
                    <div className="px-6">
                        <div className="space-y-2">
                            {filteredSidebar.map((item, index) => {
                                const isActive = location.pathname === item.link;
                                return (
                                    <Link
                                        key={index}
                                        to={item.link}
                                        className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                                            isActive
                                                ? 'bg-blue-50 text-blue-600'
                                                : 'text-gray-700 hover:bg-gray-100'
                                        }`}
                                    >
                                        {item.icon}
                                        {item.name}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </nav>
            </div>

            {/* Main Content */}
            <div className="flex-1 lg:ml-0">
                {/* Header */}
                <header className="bg-white shadow-sm border-b px-6 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                        <button
                            onClick={() => setSidebarOpen(true)}
                            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 mr-4"
                        >
                            <Menu className="w-6 h-6" />
                            </button>
                            <h2 className="text-xl font-semibold text-gray-800">Welcome back! {namaPetugas} </h2>
                        </div>
                        
                        <div className="flex items-center space-x-4">
                            <button style={styles.button} onClick={() => handleSignOut()}> Sign out</button>
                        </div>
                    </div>
                </header>

                {/* Dashboard Content */}
                <main className="p-6">
                    <Outlet />
                </main>
            </div>

            {/* { pilihPetugas && <></> } */}

            {/* Overlay for mobile */}
            {sidebarOpen && (
                <div 
                className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
                onClick={() => setSidebarOpen(false)}
                />
            )}
        </div>
    );
}
